import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Card, Col, PageHeader, Row, Spin } from "antd";

import { PriceFormat } from "scripts/helpers";
import { setRoute } from "scripts/reducer";
import API from "scripts/api";
import Resources from "scripts/resources";

const Component = ({ currency, onSetRoute, parentName, routeName }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const {
		coursesCount,
		pendingCommentsCount,
		todayIncome,
		todayTransactionsCount,
		todayUsersCount,
		totalCommentsCount,
		totalIncome,
		totalTransactionsCount,
		totalUsersCount,
		loaded,
	} = state;

	const componentDidMount = () => {
		onSetRoute({ openKey: parentName, selectedKey: routeName });

		API.dashboard()
			.then((data) => {
				setState((prevState) => ({ ...prevState, ...data, loaded: true }));
			})
			.catch(() => {
				setState((prevState) => ({ ...prevState, loaded: true }));
			});
	};

	useEffect(componentDidMount, []);

	return (
		<>
			<PageHeader title={Resources.dashboard} />
			{loaded ? (
				<Row gutter={[16, 16]}>
					<Col xs={24} sm={12} md={6}>
						<Card bordered={false}>
							<Card.Meta
								title={`${totalUsersCount} ${Resources.person}`}
								description={`${Resources.total} ${Resources.users}`}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={6}>
						<Card bordered={false}>
							<Card.Meta
								title={`${todayUsersCount} ${Resources.person}`}
								description={`${Resources.users} ${Resources.today}`}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={6}>
						<Card bordered={false}>
							<Card.Meta
								title={`${PriceFormat(totalIncome)} ${currency}`}
								description={`${Resources.total} ${Resources.income}`}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={6}>
						<Card bordered={false}>
							<Card.Meta
								title={`${PriceFormat(todayIncome)} ${currency}`}
								description={`${Resources.income} ${Resources.today}`}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={6}>
						<Card bordered={false}>
							<Card.Meta
								title={`${totalTransactionsCount} ${Resources.number}`}
								description={`${Resources.total} ${Resources.transaction}`}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={6}>
						<Card bordered={false}>
							<Card.Meta
								title={`${todayTransactionsCount} ${Resources.number}`}
								description={`${Resources.transaction} ${Resources.today}`}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={6}>
						<Card bordered={false}>
							<Card.Meta
								title={`${coursesCount} ${Resources.number}`}
								description={`${Resources.total} ${Resources.course}${Resources.ha}`}
							/>
						</Card>
					</Col>
				</Row>
			) : (
				<Spin className="sp-center-spin" />
			)}
		</>
	);
};

export default connect(
	(state) => {
		return {
			currency: state.settings.currency,
		};
	},
	(dispatch) => {
		return {
			onSetRoute: (data) => dispatch(setRoute(data)),
		};
	}
)(Component);
